<template>
    <svg class="mark" viewBox="0 0 100 100" overflow="visible" data-mark="balance2" aria-hidden="true">
        <polygon class="balance__triangle" stroke-width="2" stroke-linejoin="round" points="50,66 71,96 29,96" />
        <g ref="balBowl" class="balance__bowl">
            <path class="balance__bowl-shape" d="M20 36 A30 30 0 0 0 80 36 Z" />
            <circle ref="balBall" class="balance__ball" cx="50" cy="27" r="9" />
        </g>
    </svg>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";

const balBowl = ref<SVGGElement | null>(null);
const balBall = ref<SVGCircleElement | null>(null);
const BAL_PERIOD = 2.8;
const BAL_TRAVEL = 18;
const BAL_LEAN = 13;
const BAL_LAG = 0.5;
let rafId: number | null = null;

onMounted(() => {
    const reduced = typeof globalThis.matchMedia === "function" && globalThis.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!reduced && typeof globalThis.requestAnimationFrame === "function") {
        const frame = (now: number) => {
            const w = (now / 1000) * ((Math.PI * 2) / BAL_PERIOD);
            balBall.value?.setAttribute("cx", (50 + BAL_TRAVEL * Math.sin(w)).toFixed(2));
            balBowl.value?.setAttribute("transform", `rotate(${(BAL_LEAN * Math.sin(w - BAL_LAG)).toFixed(2)} 50 66)`);
            rafId = globalThis.requestAnimationFrame(frame);
        };
        rafId = globalThis.requestAnimationFrame(frame);
    }
});

onUnmounted(() => {
    if (rafId !== null) {
        globalThis.cancelAnimationFrame(rafId);
    }
});
</script>

<style scoped>
@reference "../../../../css/tailwind.css";

@layer components {
    .mark {
        @apply block size-full overflow-visible;
    }

    .balance__triangle {
        fill: var(--tonal-teal-base);
        stroke: var(--tonal-teal-base);
    }

    .balance__bowl-shape {
        fill: var(--color-valence-mint-300);
    }

    .balance__ball {
        fill: var(--tonal-teal-strong);
    }
}
</style>
